import React, { useEffect } from 'react';
import M from "materialize-css";

export default function Tabs({ tabs = [], onTabChange }) {
  useEffect(initializeTabs, []);

  function initializeTabs() {

    M.Tabs.init(document.getElementsByClassName("tabs")[0], {});

  };

  return (
    <div className="col s12">
      <ul className="tabs">
        {
          tabs.map(tab => (
            <li className="tab col s3" onClick={() => onTabChange(tab.name)} key={tab.name}>
              <a href={`#${tab.name}`}>{tab.label}</a>
            </li>
          ))
        }
      </ul>
    </div >
  );
}
